import { format, fromUnixTime } from "date-fns";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function Weather(props) {
  const [weather, setWeather] = useState([]);
  const match = useParams<{ community: string }>();

  useEffect(() => {
    let url = `https://api.openweathermap.org/data/2.5/forecast?q=durham,nc,us&units=imperial&appid=3e4fc5aa1152784065c9bc0e7a456b3c`;

    if (match.community === "fuquay") {
      url = `https://api.openweathermap.org/data/2.5/forecast?q=fuquay-varina,nc,us&units=imperial&appid=3e4fc5aa1152784065c9bc0e7a456b3c`;
    }

    if (match.community === "wakefield") {
      url = `https://api.openweathermap.org/data/2.5/forecast?q=wakefield,nc,us&units=imperial&appid=3e4fc5aa1152784065c9bc0e7a456b3c`;
    }

    if (match.community === "apex") {
      url = `https://api.openweathermap.org/data/2.5/forecast?q=apex,nc,us&units=imperial&appid=3e4fc5aa1152784065c9bc0e7a456b3c`;
    }

    fetch(url)
      .then((res) => res.json())
      .then((json) => {
        // console.log("weather", json);
        setWeather(json.list.slice(0, 3));
      });
  }, []);

  return (
    <div className="weather">
      {!props.noWeather && (
        <>
          <div className="weather__title">
            Weather
            <br />
            Today:
          </div>
          <div className="weather__items">
            {weather.map((w, i) => {
              const date = fromUnixTime(w.dt);
              return (
                <React.Fragment key={i}>
                  <div className="weather__item">
                    <div className="weather__time">
                      {format(date, "h:mmaaa")}
                    </div>
                    <div className="weather__image">
                      <img
                        src={`http://openweathermap.org/img/wn/${w.weather[0].icon}@2x.png`}
                      />
                    </div>
                    <div className="weather__temp">
                      {Math.ceil(w.main.temp)}°
                    </div>
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </>
      )}

      <div className="flower">
        <img src="/img/flowers.jpg" />
      </div>
    </div>
  );
}
